<form-layout
    [showSave]="false"
    (onSave)="onSaveClick()"
    (onBack)="onBackClick()"
    (onNext)="onSaveAndNextClick()">

    <form [formGroup]="attachmentProcessStepForm">
        <attachments formControlName="attachments" [documentTypes]="documentTypes" [AnfrageId]="AnfrageId" [rechtsform]="rechtsform"></attachments>
    </form>
</form-layout>
